// Centralised label builders so every dropdown / table shows entities the
// same way. Cases always surface BOTH the internal number AND the court case
// number when both are available.

export function caseLabel(c) {
    if (!c) return "";
    const parts = [];
    if (c.internal_number) parts.push(c.internal_number);
    if (c.court_case_number) parts.push(c.court_case_number);
    if (c.title) parts.push(c.title);
    return parts.join(" · ");
}

/** Compact case label for dropdowns where horizontal space is tight. */
export function caseLabelShort(c) {
    if (!c) return "";
    const head = c.internal_number || "";
    const court = c.court_case_number ? ` · ${c.court_case_number}` : "";
    return `${head}${court}` || c.title || "";
}

export function clientLabel(c) {
    if (!c) return "";
    return c.code ? `${c.code} · ${c.name}` : (c.name || "");
}
